import PropTypes from 'prop-types';
import React from 'react';
import css, {caret} from './styles.scss';

const Caret = ({side, className}) => (
  <span className={`${caret} ${css[side]} ${className} dib mh1`} />
);

Caret.propTypes = {
  side: PropTypes.oneOf(['top', 'right', 'left', 'bottom']),
  className: PropTypes.string,
};

Caret.defaultProps = {
  side: 'top',
  className: '',
};

export default Caret;
